const knowledgeHub = {
    
    elements: {},

    insidedExpanded: false,

    toggleSearch(button) {

        const searchContainerId = button.getAttribute('data-search');;

        // clear out any formerly visible panel
        Array.prototype.forEach.call( this.elements.searchElements, (element) => {

            // hide the search panel
            element.style.display = 'none';

            // if the search input exists and doesn't match the button that was just clicked
            // zero out any existing field input and hide the search results panel (Algolia only)
            const id = '#' + element.getAttribute('id');
            const searchInput = element.querySelector('input[type="text"]');

            if( searchInput && id !== searchContainerId )
            {
                searchInput.value = '';
                const searchResults = element.querySelector('.ds-dropdown-menu');
                if( searchResults )
                {
                    searchResults.style.display = 'none';
                }
            }
        });

        // reset any active button class
        Array.prototype.forEach.call( this.elements.searchToggles, (element)=> {
            element.classList.remove('active');
        });

        // find the requested search wrapper & button
        const searchElement = document.querySelector( searchContainerId );
        const searchInput = searchElement.querySelector('input[type="text"]');
        
        searchElement.style.display = 'block';
        searchElement.style.height = 'auto';

        // if there's an input (Algolia only), focus on it
        if( searchInput )
        {
            searchInput.focus();
        }

        // button in active state
        button.classList.add('active');
         
        // if Community  (inSided only) was clicked, show the panel
        if( searchContainerId === '#community')
        {
            document.body.classList.add('show-community');
            if( ! this.insidedExpanded )
            {
                const button = document.querySelector('button.insided-conversational-trigger-floating');
                if( button )
                {
                    button.click();
                    this.insidedExpanded = true;
                }
            }
        }
        else
        {
            
            document.body.classList.remove('show-community');
        }
    },

    cacheDom() {
        const searchToggles = document.querySelector('.search-mode');
        this.elements.searchElements = document.querySelectorAll('.search-wrapper');
        if( searchToggles )
        {
            this.elements.searchToggles = searchToggles.querySelectorAll('button');
        }
    },

    bind() {
        if( this.elements.searchElements && this.elements.searchToggles )
        {
            Array.prototype.forEach.call( this.elements.searchToggles, (element) => {
                element.addEventListener('click', (e) => this.toggleSearch(e.target) );
            });
        }
    },

    init() {
        this.cacheDom();
        this.bind();
    }
};

export default knowledgeHub;